var _g, _g2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRole = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "manage_accounts_black_24dp",
    width: 22.049,
    height: 22.049,
    viewBox: "0 0 22.049 22.049",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2437",
    "data-name": "Group 2437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8283",
    "data-name": "Path 8283",
    d: "M0,0H22.049V22.049H0Z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2439",
    "data-name": "Group 2439",
    transform: "translate(1.837 3.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2438",
    "data-name": "Group 2438",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8284",
    "data-name": "Path 8284",
    d: "M9.965,13.018c-.2-.009-.4-.018-.616-.018a11.829,11.829,0,0,0-6.073,1.672A2.685,2.685,0,0,0,2,17v1.516a.921.921,0,0,0,.919.919h7.589A6.4,6.4,0,0,1,9.35,15.756,6.5,6.5,0,0,1,9.965,13.018Z",
    transform: "translate(-2 -5.005)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(4.163 0.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8285",
    "data-name": "Path 8285",
    d: "M20.065,15.594a3.986,3.986,0,0,0-.055-.579l.772-.671a.462.462,0,0,0,.092-.579l-.542-.937a.449.449,0,0,0-.542-.2l-.974.331a3.35,3.35,0,0,0-.992-.579l-.2-1a.462.462,0,0,0-.45-.367H16.087a.462.462,0,0,0-.45.367l-.2,1a3.35,3.35,0,0,0-.992.579l-.974-.331a.455.455,0,0,0-.542.2l-.542.937a.462.462,0,0,0,.092.579l.772.671a3.985,3.985,0,0,0-.055.579,3.985,3.985,0,0,0,.055.579l-.772.671a.462.462,0,0,0-.092.579l.542.937a.449.449,0,0,0,.542.2l.974-.331a3.35,3.35,0,0,0,.992.579l.2,1a.462.462,0,0,0,.45.367h1.084a.462.462,0,0,0,.45-.367l.2-1a3.35,3.35,0,0,0,.992-.579l.974.331a.455.455,0,0,0,.542-.2l.542-.937a.462.462,0,0,0-.092-.579l-.772-.671A3.986,3.986,0,0,0,20.065,15.594ZM16.62,17.432a1.837,1.837,0,1,1,1.837-1.837A1.843,1.843,0,0,1,16.62,17.432Z",
    transform: "translate(-2.839 -4.844)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRole, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/role.54c03745.svg";
export { ForwardRef as ReactComponent };